<template>
	<v-card>
		<v-card-title>{{$vuetify.lang.t('$vuetify.custom.user.user') + $vuetify.lang.t('$vuetify.custom.detail')}}</v-card-title>
		<v-card-text>
			<v-container>
				<v-form ref="form">
				<table style="width:100%;">
					<tr>
						<td rowspan="2">
						      <v-img
						      	style="width:8vw;"
						        :src="avatorShow"
						      />
						       <v-file-input accept="image/*" v-model="file" @change="fileChange" :label="$vuetify.lang.t('$vuetify.custom.user.uploadAvatar')"></v-file-input>
						</td>
						<td>
							<v-text-field :label="$vuetify.lang.t('$vuetify.custom.user.username')" required :value="formData.username" readonly style="width:13vw;"></v-text-field>
						</td>
						<td>
							<v-text-field :label="$vuetify.lang.t('$vuetify.custom.user.realname')" v-model="formData.realname" :rules="rules.realRules" style="width:13vw;"></v-text-field>
						</td>
					</tr>
					<tr>

						<td>
							<!-- <v-text-field :label="$vuetify.lang.t('$vuetify.custom.gender')" required :value="formData.gender" style="width:13vw;"></v-text-field> -->
							<v-radio-group v-model="formData.isWorking" row readonly>
						      <v-radio :label="$vuetify.lang.t('$vuetify.custom.user.work')" :value='1'></v-radio>
						      <v-radio :label="$vuetify.lang.t('$vuetify.custom.user.notWork')" :value='0'></v-radio>
						</v-radio-group>
						</td>
						<td>
							<v-text-field :label="$vuetify.lang.t('$vuetify.custom.phone')" v-model="formData.phone" style="width:13vw;" :rules="rules.phoneRules"></v-text-field>
						</td>
					</tr>
				</table>
				<v-row>
					<v-col cols="12" sm="6" md="6">
						<v-text-field :label="$vuetify.lang.t('$vuetify.custom.user.email')" v-model="formData.email" :rules="rules.emailRules"></v-text-field>
					</v-col>
					<v-col cols="12" sm="6" md="6">
						<v-text-field :label="$vuetify.lang.t('$vuetify.custom.user.identity')" v-model="formData.identity" :rules="rules.identityRules"></v-text-field>
					</v-col>
					
					
				</v-row>
				<v-row>
					<v-col cols="12" sm="6" md="4">
						<v-text-field :label="$vuetify.lang.t('$vuetify.custom.user.qqid')" v-model="formData.qqid" :rules="rules.qqRules"></v-text-field>
					</v-col>
					<v-col cols="12" sm="6" md="4">
						<v-text-field :label="$vuetify.lang.t('$vuetify.custom.user.weixin')" v-model="formData.weixin"></v-text-field>
					</v-col>
					<v-col cols="12" sm="6" md="4">
						<!-- <v-text-field :label="$vuetify.lang.t('$vuetify.custom.user.isWorking')" required :value="formData.isWorking"></v-text-field> -->
						
						<v-radio-group v-model="formData.gender" row>
						      <v-radio :label="$vuetify.lang.t('$vuetify.custom.user.man')" :value="0"></v-radio>
						      <v-radio :label="$vuetify.lang.t('$vuetify.custom.user.women')" :value="1"></v-radio>
						    </v-radio-group>
					</v-col>
					
				</v-row>
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<v-text-field :label="$vuetify.lang.t('$vuetify.custom.user.address')" v-model="formData.address"></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" sm="6" md="4" lg="6">
						<v-menu
				          :close-on-content-click="true"
				          transition="scale-transition"
				          offset-y
				        >
				          <template v-slot:activator="{ on }">
				            <v-text-field
				              v-model="dateEntryFormatted"
				              :label="$vuetify.lang.t('$vuetify.custom.user.dateEntry')"
				              persistent-hint
				              v-on="on"
				            ></v-text-field>
				          </template>
				          <v-date-picker v-model="formData.dateEntry" no-title ></v-date-picker>
				        </v-menu>
			    	</v-col>
			    	<v-col cols="12" sm="6" md="4" lg="6">
						<v-menu
				          :close-on-content-click="true"
				          transition="scale-transition"
				          offset-y
				        >
				          <template v-slot:activator="{ on }">
				            <v-text-field
				              v-model="quitDateFormatted"
				              :label="$vuetify.lang.t('$vuetify.custom.user.notWork') + $vuetify.lang.t('$vuetify.custom.date')"
				              persistent-hint
				              v-on="on"
				            ></v-text-field>
				          </template>
				          <v-date-picker v-model="formData.quitDate" no-title ></v-date-picker>
				        </v-menu>
			    	</v-col>
				</v-row>
			</v-form>
			</v-container>
		</v-card-text>
		<v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="cancelBtn">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}</v-btn>
          <v-btn color="green darken-1" text @click="save">{{ $vuetify.lang.t('$vuetify.custom.preservation') }}</v-btn>
        </v-card-actions>
	</v-card>
</template>
<script>
import ETDatePicker from '@/components/datepicker/ETDatePicker'
 	export default{
		props:{
			showDetail:Boolean,
			userId:String
		},
		model:{
			prop:'showDetail',
			event:'changeShowDetail'

		},
		data(){
			return{
				formData:{
					id:'',
					userId:'',
					username:'',
					realname:'',
					gender:'',
					phone:'',
					email:'',
					identity:'',
					address:'',
					isWorking:'',
					qqid:'',
					weixin:'',
					dateEntry:'',
					quitDate:'',
					avator:'',
				},
				file:null,
				rules:{
					identityRules:[
	               		v => !v || /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(v)  || '身份证号不规范'
	               	],
	               	qqRules:[
	               		v => !v ||  /^[1-9][0-9]{4,10}/.test(v) || 'QQ号码输入错误'
	               		// ,v => v.length <= 10 || 'QQ号码不能超过10位'
	               	],
	               	realRules:[
	               		v => !v || /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/.test(v) || '请输入正确的姓名'
	               	],
	               	phoneRules:[
	               		v => !v || /^1[3456789]\d{9}$/.test(v) || '手机号格式错误'
	               	],
	               	emailRules:[
	               		v => !v || /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/.test(v) || '邮箱格式错误'
	               	]
				},
				imgSrc:require('@/assets/man.png'),
				form1:null,
				
				
			}
		},
		computed: {
	      dateEntryFormatted () {
	        // return this.formatDate(this.formData.dateEntry)
	        return this.formData.dateEntry
	      },
	      quitDateFormatted(){
	      	// return this.formatDate(this.formData.quitDate)
	      	return this.formData.quitDate
	      },
	      avatorShow(){
	    		if(this.formData.avator != null && this.formData.avator != ''){
	    			return this.$file.fileDownload(this.formData.avator)
	    		}else{
	    			return this.imgSrc;
	    		}
	    		
	    	}
	    },
	    watch: {
	      'showDetail' (val) {
	      	// console.info('showDetail',val);

	        	if(val){
	        		this.file = null;
	        		this.getUserInfo();
	        	} 
	    	},
	    },
	    mounted(){
	    	// console.log(new Date().toISOString());
	    	// console.log(this.parseDate('2020/05/28'));
	    },
	    created(){
	    	this.getUserInfo();
	    },
		methods:{
			async fileChange(){
				//定义formData对象
		      	this.from1 = new FormData();
		      	//文件上传后保存的路径 以实际情况为准 如果不填为default
		      	this.from1.append("filePath", "user");
		      	//具体的文件对象放入表单对象中
		      	this.from1.append('file', this.file);
		     	
			},
			getUserInfo(){
				// console.info("getUserInfo",this.userId);
				this.$api.sysUser.getUserInfo(this.userId).then(data =>{
					if(data.flag){
						console.info('data.obj',data.obj);
						 for(var key in this.formData){
						 	this.formData[key] = data.obj[key];
						 	if(data.obj[key] == null){
						 		this.formData[key] = ''
						 	}
						 	
						 }
						 if(this.formData.avator == ''){
			    			if(this.formData.gender == 0){
								this.imgSrc = require('@/assets/man.png')
			    			}else{
			    				this.imgSrc = require('@/assets/women.png')
			    			}
				    	}else{
				    		this.imgSrc = this.formData.avator;
				    	}
						 // console.info('this.formData',this.formData);
					}else{
						this.$dialog.alert(data.msg)
					}
				});
			},
			cancelBtn(){
				this.$emit('changeShowDetail',false)
			},
			async save(){
				if(this.$refs.form.validate()){
					console.info("this.formData",this.formData);
					if(this.from1 !== undefined && this.from1 != null){
						//调用时一定要加上await关键字  重点! 重点! 重点!
						
				      	let file = await this.$file.fileUpload(this.from1)
				      	// console.info("file",file);
				      	if(file.fileId !== undefined && file.fileId != null && file.fileId != ''){
				      		this.formData.avator = file.fileId
				      	}
				      	
					}
					

					this.$api.sysUser.saveUserDetail(this.formData).then(data =>{
						 if (data.flag) {
			              this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.preservation') + this.$vuetify.lang.t('$vuetify.custom.success'));
			              this.$emit('initialize')
			              this.$emit('changeShowDetail',false)
			              
			            }else{
			              this.$dialog.alert(data.msg)
			              this.$refs.form.reset()
			            }
					});
				}
			},
			//格式化日期
			formatDate (date) {
		        if (!date) return null

		        const [year, month, day] = date.split('-')
		        return `${month}/${day}/${year}`
		    },
		    //格式化日期
	      	parseDate (date) {
		        if (!date) return null

		        const [month, day, year] = date.split('/')
		    	var str = year+month+day
		        //return `${year}-${month.length<2}?${month.padStart(2, '0')}-${day.padStart(2, '0')}`
		        //return `${year}-(${month.length<2}?'0'+${month}:${month})-(${day.length<2}?'0'+${day}:${day})`

		        return new Date(str);
		    
		    },

		},
		components: {
		  ETDatePicker
		}
	}
</script>
